// extracted by mini-css-extract-plugin
export default {"root":"SingleSignOnButton_root__40Mrc","icon":"SingleSignOnButton_icon__w5P3L"};